<template>
  <div class="site-profile-container">
    <a
      @click="goBack"
      class="nav-back"
    >{{ $t('back') }}</a>
    <hr>
    <div class="header">
      <label class="title">{{ $t('settings.tab.siteProfile') }}</label>
      <div class="btns">
        <button
          class="btn btn--orange"
          v-if="editable && !isEdit"
          @click="edit"
        >{{ $t('action.edit') }}</button>
        <button
          class="btn btn--darkblue"
          v-if="isEdit"
          @click="cancel"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn btn--orange"
          v-if="isEdit"
          @click="save"
        >{{ $t('action.save') }}</button>
      </div>
    </div>
    <div class="main">
      <div class="tabs">
        <label
          v-for="site in sites"
          :key="site.code"
          @click="updateCurrentSite(site.id)"
          :class="{active: currentSiteId === site.id}"
        >{{ site.code }}</label>
      </div>
      <div class="container">
        <div class="basic-info">
          <SiteProfileForm
            ref="siteProfileForm"
            :site="siteDetail"
            :isEdit="isEdit"
          />
        </div>
        <div class="users">
          <SiteProfileUsers :users="users" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { aclHelper } from '@/utils/aclHelper'
import { getLocationDetail, getLocations } from '@/api/locations/request'
import { ROUTER_PATHS } from '@/constants/router'
import SiteProfileForm from './SiteProfileForm'
import SiteProfileUsers from './SiteProfileUsers'

export default {
  name: 'SiteProfile',
  components: {
    SiteProfileForm,
    SiteProfileUsers,
  },
  data () {
    return {
      currentSiteId: this.$route.params.id,
      siteDetail: {},
      sites: [],
    }
  },
  computed: {
    editable () {
      return aclHelper.getSettingsUpdateAccess()
    },
    isEdit () {
      return this.editable && !!this.$route.query.isEdit
    },
    users () {
      return this.siteDetail.users || []
    },
  },
  methods: {
    edit () {
      this.toEditMode()
    },
    toPreviewMode (id = this.currentSiteId) {
      this.$router.replace({name: ROUTER_PATHS.SITE_PROFILE, params: { id }})
    },
    toEditMode () {
      this.$refs.siteProfileForm.setEditModeSignatureNum()
      this.$router.replace({name: ROUTER_PATHS.SITE_PROFILE, params: {id: this.currentSiteId}, query: {isEdit: true}})
    },
    async save () {
      if (!this.$refs.siteProfileForm.validate()) {
        return
      }
      await this.$refs.siteProfileForm.save()
      this.toPreviewMode()
      await this.reload()
      await this.$refs.siteProfileForm.reset()
    },
    async cancel () {
      await this.$refs.siteProfileForm.reset()
      this.toPreviewMode()
    },
    async reload () {
      this.initCurrentSiteId()
      await this.initSites()
      await this.loadCurrentSite()
    },
    initCurrentSiteId () {
      this.currentSiteId = this.$router.currentRoute.params.id
    },
    async initSites () {
      const locations = await getLocations()
      this.sites = _.orderBy(locations, 'code')
    },
    async loadCurrentSite () {
      const res = await getLocationDetail(this.currentSiteId)
      this.siteDetail = {
        ...res,
      }
    },
    async updateCurrentSite (id) {
      if (id === this.currentSiteId) return
      this.toPreviewMode(id)
    },
    getIsEdit () {
      return this.editable && !!this.$route.query.isEdit
    },
    goBack () {
      this.$router.replace({name: 'sites'})
    },
  },
  watch: {
    async '$route.params.id' () {
      await this.reload()
    },
  },
  async mounted () {
    await this.reload()
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.site-profile-container {
  width: 100%;
  padding: 0 24px;
}
.header {
  padding-bottom: 20px;
  .title {
    display: inline-block;
    font-family: Georgia;
    font-size: 18px;
    font-weight: bold;
    color: #0C3A58;
  }
  .btns {
    float: right;
    button {
      margin-left: 10px;
    }
  }
}
.main {
  padding: 5px;
  background: #f8f8f8;
  min-height: calc(100vh - 370px);
  .tabs {
    display: block;
    margin: 10px 0 15px 0;
    background: transparent;
    border: 0;
    label {
      display: inline-block;
      background: white;
      margin-right: 5px;
      margin-bottom: 5px;
      font-weight: bold;
      padding: 5px 20px;
      cursor: pointer;
      &.active {
        background: #0C3A58;
        color: white;
      }
    }
  }
}
.container {
  display: flex;
  margin-top: 10px;
  .basic-info {
    flex: 3;
    background: white;
    margin-right: 15px;
    padding-bottom: 15px;
  }
  .users {
    flex: 2;
    background: white;
    padding: 15px;
  }
}
</style>
